import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import buildLoyaltyBurningPointItems from 'checkout/lib/utils/loyalty/buildLoyaltyBurningPointItems'
import getCheckoutLoyaltyPointBurnCalculationView from './getCheckoutLoyaltyPointBurnCalculationView'

const getCheckoutLoyaltyBurningPointItems = createSelector(
  (state: App.State) => state.checkout.loyalty.pointsToBurn,
  (state: App.State) => getCheckoutLoyaltyPointBurnCalculationView(state),
  (
    pointsToBurn,
    pointBurnCalculationView,
  ): Array<App.Checkout.LoyaltyBurningPointItem> => {
    if (!pointBurnCalculationView.data) return EmptyArray
    return buildLoyaltyBurningPointItems(pointsToBurn, pointBurnCalculationView.data)
  },
)

export default getCheckoutLoyaltyBurningPointItems
